import React from 'react';
import { Multiselect } from 'multiselect-react-dropdown';
import { strings } from '../../localization';
import { Select } from 'antd';

const MeterMultiSelectBox = ({meterChange, selectedMeters, metersData, isAdmin = false}) => {

    const options = [];
    const selectedValues = [];

    const createItem = (meter) => {
        const id = meter.get('id');
        const name = meter.get('name');
        let cat = meter.get('home') ? `[${meter.getIn(['home', 'name'])}]` : '';
        if (isAdmin && meter.get('home') && meter.getIn(['home', 'ownerUser'])) {
            cat = `[${meter.getIn(['home', 'ownerUser', 'surename']) || ''}
                 ${meter.getIn(['home', 'ownerUser', 'name']) || ''}] ${cat}`;
        }

        options.push({ name, cat, id });
        if (selectedMeters && selectedMeters.includes(id)) {
            selectedValues.push({ name, cat, id });
        }
    }

    const onSelect = (selectedList, selectedItem) => {
        meterChange(selectedList.map(({id}) => id));
    }

    const onRemove = (selectedList, removedItem) => {
        meterChange(selectedList.map(({id}) => id));
    }
    return (
        <span style={{ display: 'inline-block' }}>
            <span>{strings.dashboard.selectedMeter}</span>
            <Multiselect
                style={{display: 'inline-block', searchBox: { borderRadius: "0px" }}}
                options={options}               // Options to display in the dropdown
                selectedValues={selectedValues} // Preselected value to persist in dropdown
                onSelect={onSelect}             // Function will trigger on select event
                onRemove={onRemove}             // Function will trigger on remove event
                displayValue="name"             // Property name to display in the dropdown options
                groupBy="cat"                   // Property for grouing by home
                closeIcon="close"
            >
                {metersData &&
                metersData.map(meter => (
                    createItem(meter)
                ))}
            </Multiselect>
        </span>
    );
};

export default MeterMultiSelectBox;